@if (!product) {
  <div class="loading-overlay">
    <mat-spinner></mat-spinner>
  </div>
}
@if (product) {
  <mat-card class="lifecycle-page">
    <div class="lifecycle-page__header">
      <div class="lifecycle-page__title">
        <mat-icon>account_tree</mat-icon>
        <h2>Product Lifecycle</h2>
        <span class="lifecycle-page__subtitle">
          {{ product.barcode ?? product.reference ?? product.key }}
        </span>
      </div>
      <button mat-stroked-button (click)="onBack()">
        <mat-icon>arrow_back</mat-icon>
        Back to Product
      </button>
    </div>

    <ul class="lifecycle-tree" [attr.data-testid]="'lifecycle-tree'">
      @for (node of nodes; track trackByLabel($index, node)) {
        <li class="lifecycle-tree__node lifecycle-tree__node--level-0">
          <div class="lifecycle-tree__row">
            <div class="lifecycle-tree__content">
              <span class="lifecycle-tree__label">{{ node.label }}</span>
              @if (node.sublabel) {
                <span class="lifecycle-tree__sublabel">{{ node.sublabel }}</span>
              }
              @if (node.countText) {
                <span class="lifecycle-tree__count">{{ node.countText }}</span>
              }
            </div>
            <div class="lifecycle-tree__actions">
              @if (node.link) {
                <a mat-icon-button [href]="node.link" matTooltip="Open details" matTooltipPosition="left">
                  <mat-icon>open_in_new</mat-icon>
                </a>
              }
              <button
                mat-icon-button
                [disabled]="!node.historyAvailable"
                matTooltip="Audit history — coming soon"
                matTooltipPosition="left"
              >
                <mat-icon>history</mat-icon>
              </button>
            </div>
          </div>

          @if (node.children && node.children.length > 0) {
            <ul class="lifecycle-tree__children">
              @for (child of node.children; track trackByLabel($index, child)) {
                <li class="lifecycle-tree__node lifecycle-tree__node--level-1">
                  <div class="lifecycle-tree__row">
                    <div class="lifecycle-tree__content">
                      <span class="lifecycle-tree__label">{{ child.label }}</span>
                      @if (child.sublabel) {
                        <span class="lifecycle-tree__sublabel">{{ child.sublabel }}</span>
                      }
                    </div>
                    <div class="lifecycle-tree__actions">
                      @if (child.link) {
                        <a mat-icon-button [href]="child.link" matTooltip="Open details" matTooltipPosition="left">
                          <mat-icon>open_in_new</mat-icon>
                        </a>
                      }
                      <button
                        mat-icon-button
                        [disabled]="!child.historyAvailable"
                        matTooltip="Audit history — coming soon"
                        matTooltipPosition="left"
                      >
                        <mat-icon>history</mat-icon>
                      </button>
                    </div>
                  </div>

                  @if (child.children && child.children.length > 0) {
                    <ul class="lifecycle-tree__children">
                      @for (grandchild of child.children; track trackByLabel($index, grandchild)) {
                        <li class="lifecycle-tree__node lifecycle-tree__node--level-2">
                          <div class="lifecycle-tree__row">
                            <div class="lifecycle-tree__content">
                              <span class="lifecycle-tree__label">{{ grandchild.label }}</span>
                              @if (grandchild.sublabel) {
                                <span class="lifecycle-tree__sublabel">{{ grandchild.sublabel }}</span>
                              }
                            </div>
                            <div class="lifecycle-tree__actions">
                              @if (grandchild.link) {
                                <a mat-icon-button [href]="grandchild.link" matTooltip="Open details" matTooltipPosition="left">
                                  <mat-icon>open_in_new</mat-icon>
                                </a>
                              }
                              <button
                                mat-icon-button
                                [disabled]="!grandchild.historyAvailable"
                                matTooltip="Audit history — coming soon"
                                matTooltipPosition="left"
                              >
                                <mat-icon>history</mat-icon>
                              </button>
                            </div>
                          </div>
                        </li>
                      }
                    </ul>
                  }
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>
  </mat-card>
}
